import React from 'react'
import { View } from 'react-native'
import TileGlass from '@ui/tiles/TileGlass'
import Typography from '@ui/typography'
import cn from '@ui/utils/cn'
import Gradient from '@ui/effects/Gradient'
import { colors } from '@ui/colors'
import {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
} from 'react-native-reanimated'
import Border from '@ui/effects/Border'
import { tileSmall } from '@ui/theme/values'
import { TileSmallProps as Props } from './types'

const borderRadius = 24

export default function TileSmall({
  title,
  desc,
  image,
  tileGlassProps,
  className,
  startComponent,
  endComponent,
  backgroundColors = [colors.gray[75], colors.gray[0]],
  backgroundColorsPressed = [colors.gray[200], colors.gray[75]],
  borderColor,
}: Props) {
  const animation0 = useSharedValue(0)
  const animation = tileGlassProps?.animation || animation0

  const styleGradientPressed = useAnimatedStyle(() => {
    return {
      opacity: interpolate(animation.value, [0, 1], [0, 1]),
    }
  })

  return (
    <TileGlass
      image={image}
      imageStyle={[
        {
          transform: [{ translateX: 1 }, { translateY: 0 }],
        },
      ]}
      {...tileGlassProps}
      style={{ height: tileSmall.height, borderRadius, borderWidth: 0 }}
      gradient={
        <>
          <Gradient colors={backgroundColors} start={[0, 0.5]} end={[1, 0.5]} />
          <Gradient
            colors={backgroundColorsPressed}
            start={[0, 0.5]}
            end={[1, 0.5]}
            style={styleGradientPressed}
          />
        </>
      }
    >
      <Border
        style={{ borderRadius, borderColor: borderColor || colors.black10 }}
      />
      <View
        className={cn(
          'flex w-full flex-1 flex-row items-center justify-between gap-8 p-8',
          className
        )}
      >
        <View className="flex flex-row items-center gap-8">
          {startComponent && <View>{startComponent}</View>}
          <View className="gap-0">
            <Typography variant="MDB">{title}</Typography>
            {desc && (
              <Typography variant="MD" className="color-desc">
                {desc}
              </Typography>
            )}
          </View>
        </View>
        {endComponent && <View>{endComponent}</View>}
      </View>
    </TileGlass>
  )
}
